module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-640-retro-min.52a05c7c.jpg";